import TabList from '@mui/lab/TabList'
import Tab from "@mui/material/Tab"
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import styled from '@mui/system/styled';
export const CustomeFormControl = styled(FormControl)(({ theme, locale }) => ({
    width: "100%",
    margin: 0,
    '& label.Mui-focused': {
      color: "#008C8D ",
    },
  
    '& .MuiSelect-icon': {
      color: "#008C8D "
    },
    '& .MuiInputLabel-root': {
  
      fontSize: "1rem !important",
  
    },
    '@media only screen and  (min-width:280px){': {
      '& .MuiInputLabel-root': {
  
        fontSize: "1rem !important",
  
      },
    },
    '@media (min-width:768px) and (max-width:912px)': {
      '& .MuiInputLabel-root': {
  
        fontSize: "1.2rem !important",
  
      },
      width: "100%",
    },
    '@media (min-width:913px) ': {
      '& .MuiInputLabel-root': {
  
        fontSize: "1.2rem !important",
  
      },
      width: "100%",
    },
  
}));
export const ListItem = styled("li")(({ theme }) => ({ margin: theme.spacing(0.5) }));
export const CustomeCheckbox = styled(Checkbox)({
    // "&.MuiCheckbox-root": {
    //   padding: "2px"
    // }
    // padding: " 16px 16px",

  });
export const CustomeSuperTab=  styled(TabList)(({ theme, locale }) => ({
    '& .MuiTabs-flexContainer': {
        justifyContent: "initial",
        gap: "0rem"
    },
   
    '@media (min-width:768px) and (max-width:912px)': {
      
        '& .MuiTabs-flexContainer': {
           
            justifyContent: "initial",
            gap: "2rem"
        },
        
         
       

    },

    '@media (min-width:913px) ': {
       
        '& .MuiTabs-flexContainer': {
            justifyContent: "initial",
            gap: "1rem"
           
        },
       
         
       
        
    },
 }));
export const CustomeTab = styled(Tab)(({ theme, locale }) => ({
   
        color: "black",
        
        '&.Mui-selected': {
        fontWeight:"600 !important"
        },
 

   

   
 
    '& .MuiTabs-indicator': {

        backgroundColor: "white",
        height: "0"

    },
   
    
     
        opacity: 0.5,
        fontWeight:"600 !important",
        '@media (min-width:301px) and (max-width:767px)': {
            fontSize: "0.9rem ",
            // width: "50% ",
            width:"100%"
           },
    '@media (min-width:280px) and (max-width:300px)': {
  
   
        fontSize: "0.7rem ",
        width: "100% !important",
       
    },
    '@media (min-width:768px) and (max-width:912px)': {
      
        
      
            fontSize: "1rem !important",
            // width: "47.8%",
            width:"100%"
       
      

    },

    '@media (min-width:913px) ': {
       
     
       
        fontSize: "1.2rem !important",
        width: "100%",


        height: "60px",

       
        
    },

}));
  